import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import LanguageCardWithAvatarSkeleton from './LanguageCardWithAvatarSkeleton'

const LanguageCardWithAvatarPlaceholder = ({ open, children }) => {
  return (
    <LanguageCardWithAvatarSkeleton
      open={open}
      headerSection={<LoadingBox width="80%" />}
      avatarSection={
        <Box bg="white100" width="100px" height="100px" borderRadius="100%" />
      }
    >
      {children}
    </LanguageCardWithAvatarSkeleton>
  )
}

LanguageCardWithAvatarPlaceholder.propTypes = {
  open: PropTypes.bool,
}

export default LanguageCardWithAvatarPlaceholder
